import React from 'react';

import { RollbackOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { styled } from 'styled-components';

const StyledBlock = styled.div`
	display: flex;
	justify-content: center;
	//height: 100vh;
	margin: 50px 0;

	.error-container {
		text-align: center;
	}

	.error-code {
		font-size: 8em;
		color: #333;
		margin: 0;
	}

	.error-message {
		font-size: 2.5em;
		color: #555;
	}
`;

const Error500: React.FC = () => {
	const navigate = useNavigate();

	return (
		<StyledBlock>
			<div className='error-container'>
				<h1 className='error-code'>500</h1>
				<p className='error-message'>Internal Server Error</p>
				<Button
					type='primary'
					onClick={() => navigate(-1)}
					style={{ marginTop: 20 }}
					icon={<RollbackOutlined />}>
					Go to back
				</Button>
			</div>
		</StyledBlock>
	);
};

export default Error500;
